module.exports = __webpack_public_path__ + "img/s5-title.b2fac561.png";